import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Text } from "@ui-kitten/components";
import React from "react";
import { Pressable, View } from "react-native"; // Use react-native imports for web compatibility via react-native-web
import Button from "../Button";

interface BottomSheetProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}

const BottomSheet: React.FC<BottomSheetProps> = ({
  visible,
  onClose,
  children,
  title,
}) => {
  if (!visible) return null;

  // Web-specific styling using nativewind
  const backdropClass = `fixed inset-0 bg-black z-40 transition-opacity duration-300 ease-in-out ${
    visible ? "bg-opacity-50" : "bg-opacity-0"
  }`;
  // Use flex column layout for the sheet
  const sheetClass = `fixed bottom-0 left-1/2 -translate-x-1/2 bg-white rounded-t-lg shadow-lg z-50 flex flex-col max-h-[80vh] max-w-[600px] w-full transition-transform duration-300 ease-in-out ${
    visible ? "translate-y-0" : "translate-y-full"
  }`;
  // Header styles - remove margin bottom, add padding
  const headerClass =
    "flex-row justify-between items-center p-4 border-b border-gray-200 sticky top-0";
  // Content area - make it scrollable
  const contentClass = "flex-1 overflow-y-auto p-4";

  // Use Pressable for the backdrop to handle onPress for web
  return (
    <>
      <Pressable className={backdropClass} onPress={onClose} />
      <View className={sheetClass}>
        {/* Header Section - Stays Fixed */}
        <View className={headerClass}>
          <Text category="h6">{title}</Text>
          <Button appearance="ghost" onPress={onClose} size="small">
            {() => (
              <MaterialCommunityIcons name="close" size={24} color="black" />
            )}
          </Button>
        </View>
        {/* Scrollable Content Section */}
        <View className={contentClass}>{children}</View>
      </View>
    </>
  );
};

export default BottomSheet;
